var _excluded = ["children", "onChange", "options", "isOpen", "onToggle"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { Children } from 'react';
import ComboboxWrapper from "./ComboboxWrapper";
import UncontrolledMultiSelectCombobox from "./UncontrolledMultiSelectCombobox";
import checkInvariantViolations from "./util/checkInvariantViolations";

function MultiSelectCombobox(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      options = _ref.options,
      isOpen = _ref.isOpen,
      onToggle = _ref.onToggle,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  var childrenCount = Children.count(children);
  checkInvariantViolations({
    childrenTypes: Children.map(children, function (child) {
      return child === null || child === void 0 ? void 0 : child.type;
    }),
    hasOnChange: typeof onChange !== 'undefined',
    hasOptions: typeof options !== 'undefined'
  });

  if (childrenCount === 0 && options && onChange) {
    return /*#__PURE__*/React.createElement(UncontrolledMultiSelectCombobox, _extends({
      options: options,
      onChange: onChange
    }, remainingProps));
  }

  return /*#__PURE__*/React.createElement(ComboboxWrapper, _extends({
    isOpen: isOpen,
    onToggle: onToggle
  }, remainingProps), children);
}

MultiSelectCombobox.displayName = "MultiSelectCombobox";
export default MultiSelectCombobox;